import { useCallback, useState } from 'react';

/**
 * Notification conforme à la charte, en une ligne pour l'écran appelant.
 *
 * Le module examens posait un `Toast` court dans tous les cas. Deux
 * conséquences : les messages du serveur — les plus longs, comme « Le versement
 * dépasse le reste dû (1 500 FCFA) » — étaient tronqués, et un toast déclenché
 * depuis un `Dialog` passait SOUS l'assombrissement de Radix.
 *
 * `shouldUseLongToast` arbitre entre bandeau court et message centré ; le rendu
 * passe par `ToastPortal` pour sortir de la pile du dialogue. Voir
 * `PorteurNotification` pour la partie affichage.
 */
export const useNotification = () => {
  const [notification, setNotification] = useState(null);

  const notifier = useCallback((message, type = 'success', options = {}) => {
    if (!message) return;
    setNotification({ message, type, ...options });
  }, []);

  const masquer = useCallback(() => setNotification(null), []);

  return {
    notification,
    notifier,
    masquer,
    /** Raccourci : les échecs sont le cas le plus fréquent et le plus verbeux. */
    signalerEchec: useCallback(
      (message, titre = 'Opération impossible') => {
        if (!message) return;
        setNotification({ message, type: 'error', title: titre });
      },
      []
    )
  };
};

export default useNotification;
